/**
 * @file store mutations
 * @author zhangzhimeng
 */
export default {
  SET_COLUMNTREELIST (state, arr) {
    state.columnTreeList = arr
  },
  SET_FOOTERLIST (state, arr) {
    state.footerList = arr
  },
  SET_USER (state, user) {
    state.user = user
    if (user) {
      sessionStorage.setItem('user', JSON.stringify(user))
    } else {
      sessionStorage.setItem('user', null)
    }
  },
  SET_TENANT  (state, tenant) {
    state.tenant = tenant
    sessionStorage.setItem('tenant', JSON.stringify(tenant))
  },
  SET_WEBSIT  (state, websit) {
    state.websit = websit
  },
  // 导航栏目点击标识
  SET_TOKEN (state, payload) {
    state.token = payload
  },
  SET_BANNER (state, payload) {
    state.websitBanner = payload
  },
  SET_PERMISSION (state, permission) {
    // permission 为传入的权限标识集合
    // 传入的权限集合 赋值给状态中的 permission
    state.buttonPermissionList = permission
  },
  // 导航栏目点击标识
  SET_ACTIVEINDEX (state, payload) {
    state.activeIndex = payload
  },
  // 导航栏目点击对象
  SET_COLUMNITEM (state, arr) {
    state.columnItem = arr
  },
  // 导航栏目点击对象
  SET_COLUMNITEM_PARENT (state, arr) {
    state.columnItemParent = arr
  },
  // 子栏目栏目点击标识
  SET_ACTIVECHILDRENINDEX (state, payload) {
    state.activeChildrenIndex = payload
  },
  SET_CONTENTID (state, payload) {
    state.contentId = payload
  },
  SET_SITEINTRO (state, payload) {
    state.siteIntro = payload
  },
  SET_GUIDANCE (state, payload) {
    state.guidance = payload
  },
  SET_UNDERTAKE (state, payload) {
    state.undertake = payload
  },
  SET_ZIPCODE (state, payload) {
    state.zipCode = payload
  },
  SET_CONTACTMAIL (state, payload) {
    state.contactMail = payload
  },
  SET_TELEPHONE (state, payload) {
    state.telephone = payload
  },
  SET_SITEADDRESS (state, payload) {
    state.siteAddress = payload
  },
  SET_SPECIALINFO (state, payload) {
    state.specialInfo = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js